/* eslint-disable no-useless-escape */
export default {
  mobile: /(^(0[0-9]{2,3}-)?([2-9][0-9]{5,9})+(-[0-9]{1,9})?$)|(^0?[1][3-9][0-9]{9}$)/,
  email: /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/,
  skill: /^[^|]([\S\s]+[|]?)+[^|]$/,
  name: /^[\u4e00-\u9fa5·]{2,20}$/,
  companyName: /^[a-zA-Z\u4e00-\u9fa5\(\)\（\）]{2,20}$/,
  password: /^[\w!@#$%^&*\\(\\)._-]{6,20}$/,
  phone: /(^(0[0-9]{2,3}-)([2-9][0-9]{5,9})+(-[0-9]{1,9})?$)|(^0?[1][3-9][0-9]{9}$)/,
  qq: /^[1-9]\d{4,9}$/,
  idcard: /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/,
  username: /^[\u4e00-\u9fa50-9A-z·]+$/,
  resumeName: /^[\u4e00-\u9fa5·]{2,20}$/,
  jobName: /^\s*[\s\S]{2,50}\s*$/,
};
